export default "__VITE_ASSET__wAqOtQVS__"